/*
 MessagingService is a SignalR wrapper that uses the ideas of channels and events. 
 With this service you can subscribe to specific channels (or groups in signalr speak) and
 use observables to react to specific events sent out on those channels.
  
 Implementation Notes:
   For signalR, when creating the listener the function name your listening for must be camel case.
   So if the serve function is MaryHasALittleLamb() the lister must be maryHasALittleLamb().
   This behavior also applied to class properites. So if your class property sends  MyObject.FirstName as part of the encoding
   the server will publish myObject.firstName.

 For our current implementation only: The server currently pumps out notifications from the Publish method only. All the 
      functions call the Publish method. Eventually we could or may need to separate them and
      create a listener for each function we want to receive messages from.


      //$.connection.hub.start(); //this is jquery signalr
 */
declare var require: any;
import { Injectable, Inject } from "@angular/core";  
import { Subject } from "rxjs/Subject";  
import { Observable } from "rxjs/Observable";
import { HubConnection } from '@aspnet/signalr'; //HttpConnection,
import { Environment } from '../app.environment';


export enum ConnectionState {  
    Connecting = 1,
    Connected = 2,
    Reconnecting = 3,
    Disconnected = 4,
    ConnectionError = 5
}

export class MessagingConfig {  
    url: string;
    hubName: string;
    constructor(){}
}


export class MessageEvent {  
    Authorization:string;//auth token
    Name: string;
    Groups:string[] = [];
    Timestamp: Date;
    Source:string;
    Data: any;
    DataType:string; //Intake, WaitingRoom...
    Verb:string; //add, update,delete
    Json: string;
   
    constructor() {
        this.Timestamp = new Date();
        this.Groups = [];
    }
}



@Injectable()
export class MessagingService {
   private _hubConnection: HubConnection;
    private _hubName :string;
    private _subscriptions: string[] = [];
    private _authToken:string = '';


    public ConnectionState :number = ConnectionState.Disconnected;

    public Connection():HubConnection{
        return this._hubConnection;
    }
  
    constructor(  @Inject("hub.config") private messagingConfig: MessagingConfig,
                private env: Environment
               ) {

        console.log('MessagingService ServiceURL:', this.env.settings.messagingServiceUrl);
        this.messagingConfig.url = this.env.settings.messagingServiceUrl;
    }


    start(hubName : string, authToken: string  ):  Promise<void> {
        this._hubName = hubName;
        this._authToken = authToken;
        this.ConnectionState =  ConnectionState.Connecting;
       // this._hubConnection =new HubConnection(this.messagingConfig.url + '/' + this._hubName);
         
      const signalR = require("@aspnet/signalr");
      this._hubConnection = new signalR.HubConnectionBuilder().withUrl(this.messagingConfig.url + '/' + this._hubName ).build();
 
        var self = this;
        //watch for close eventfs
        this._hubConnection.onclose(function (error) {
            console.log('connection closed.');
            self.ConnectionState =  ConnectionState.Disconnected;
            self.reconnect(hubName);
            return;
        });

        console.log('MessagingService.start connecting to hub:',this.messagingConfig.url + '/' + hubName);
        return this._hubConnection.start().then(function ()  {
            console.log('start.connected.');
        })
        .catch((e) => {
            self.ConnectionState =  ConnectionState.ConnectionError;
            console.log('MessagingService.start Error while establishing connection', e);
        });
        //.finally(()=>{
           
        //    if( self.ConnectionState !=  ConnectionState.ConnectionError){
        //      self.ConnectionState ==  ConnectionState.Connected;
        //  }else{
        //         self.reconnect(hubName);
        //     }
        // });
    }

    reconnect(hubName:string): void{
        console.log('reconnect:', hubName);

        if(this.ConnectionState ==  ConnectionState.ConnectionError){
            console.log('reconnect connection error returning');  return;
        }

        if(this.ConnectionState !=  ConnectionState.Disconnected ){
            console.log('reconnect still connected returning');  return;
        }

        var self = this;

        setTimeout(function() {
            console.log('attempting connection to:', self.messagingConfig.url);

            self.start(hubName, self._authToken)
                .then(() => {
                    console.log('reconnect.then.');
                }).catch((e) => {
                    self.ConnectionState = ConnectionState.ConnectionError;
                    console.log('MessagingService.reconnect.setTimeout.start Error while establishing connection',e);
                // })
                // .finally(()=>{
                //     if(self.ConnectionState !=  ConnectionState.ConnectionError){ //!self.ConnectionError){
                //         self.ConnectionState ==  ConnectionState.Connected;
                //         //re-subscribe to the groups
                //         var evt = new MessageEvent();
                //         evt.Groups = [];
                //         evt.Groups.push( this._subscriptions );
                //         evt.Authorization = "Bearer " +  self._authToken;
                //         self.subscribe( evt );
                    
                //     }else{
                //         self.reconnect(hubName);
                //     }
                });
            
        }, 30000); //  try restarting connection after 30 seconds.     
    }

    subscribe(channel: MessageEvent): void {
        console.log('subscribe this.ConnectionState', this.ConnectionState);

        if(this.ConnectionState == ConnectionState.Disconnected){
            console.log('disconnected');
            return;
        }

        for(let group in channel.Groups){
            if( this.getIndex(group) < 0 ){
                console.log('adding to subscription:' + group);
                this._subscriptions.push(group);
            }
        }
        this._hubConnection.invoke("Subscribe", channel)
            .then(() => {
                console.log('MessagingService.sub connecting to channel:', channel);    
            })
            .catch((e) => {
                console.log('MessagingService.sub exception:', e);
            // })
            // .finally(()=>{
            //     console.log('MessagingService.sub connected to channel:', channel);    
            });
    }
 
    unsubscribe(channel: MessageEvent): void {
        console.log('unsubscribe');

        if(this.ConnectionState == ConnectionState.Disconnected){
            console.log('disconnected');
            return;
        }

        for(let group in channel.Groups){
            if( this.getIndex(group) >= 0 ){
                console.log('removing to subscription:', group);
                this._subscriptions.splice(this.getIndex(group),1);
            }
        }
        
        console.log('MessagingService.sub Unsubscribe from channel:', channel);
        this._hubConnection.invoke("Unsubscribe", channel);    
    }

    publish(channel: MessageEvent): void {        
        console.log('MessagingService.sub publish:', channel);     

        if(this.ConnectionState == ConnectionState.Disconnected){
            console.log('disconnected');
            return;
        }

        this._hubConnection.invoke("Publish",channel);
    }

    getIndex(groupName): number {
        for (let i = 0; i < this._subscriptions.length; i++) {
            if (this._subscriptions[i] === groupName) {
                return i;
            }
        }
        return -1;
      }
}